import { SemanticLayerPageHeader } from '../../components/SemanticLayerPageHeader';
import Diagram from '../Diagram';

export default function SemanticLayerDiagram() {
  return (
    <div className="w-full flex flex-col bg-background overflow-hidden" style={{ height: 'calc(100vh)' }}>
      <SemanticLayerPageHeader tab="diagram" />
      <div className="flex-1 overflow-hidden">
        <Diagram />
      </div>
    </div>
  );
}
